// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeChatPromoteAdminBody = {
  chatId: string;
  userId: string;
};

export type typeChatPromoteAdminOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { isPromoted: boolean };
};

export type typeChatPromoteAdminOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatPromoteAdminOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeChatPromoteAdminOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaChatPromoteAdminBody = {
  type: "object",
  properties: {
    chatId: { type: "string", maxLength: 3000, minLength: 1 },
    userId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["chatId", "userId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createChatPromoteAdmin(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaChatPromoteAdminBody);
  }

  return async function postChatPromoteAdmin(
    payload: typeChatPromoteAdminBody,
  ): Promise<typeChatPromoteAdminOutput200 | typeChatPromoteAdminOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postChatPromoteAdmin" failed before calling the network. #3923687b9616`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#3923687b9616" },
        },
        data: null,
      } as typeChatPromoteAdminOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/chat/promote-admin`,
      httpMethod: "POST",
      options,
    })) as typeChatPromoteAdminOutput200 | typeChatPromoteAdminOutput400;
  };
}
